import React from "react";

import type {
  IssueFile,
  IssueFileValidation,
} from "../../../../application/domain/proc-management";
import { getMaxLength } from "../../../../application/domain/proc-management/util/input-max-length";
import { FormFieldLabel } from "../../../atoms/proc-management/form";
import { InputNoticeList } from "./input-notice-list";
import { SimpleTextInput } from "./simple-text-input";
import { SimpleTextAreaInput } from "./simple-textarea-input";
import type { InputProps, PathProps } from "./types";

type Props = IssueFile &
  PathProps &
  InputProps & { validationErrors?: IssueFileValidation };

const IssueFileInput: React.FC<Props> = ({
  name,
  description,
  notice,
  onChange,
  basePath,
  disabled = false,
  shouldDisplayError,
  validationErrors,
}) => {
  return (
    <div>
      <div className="mb-2">
        <FormFieldLabel label="交付物名" bold={false} required />
        <InputNoticeList notices={["例: 所得（課税）額証明"]} />
        <SimpleTextInput
          onChange={onChange}
          basePath={[...basePath, "name"]}
          value={name}
          disabled={disabled}
          shouldDisplayError={shouldDisplayError}
          errorMsg={validationErrors?.name}
          maxLength={getMaxLength("issueFilesName")}
        />
      </div>

      <div className="mb-2">
        <FormFieldLabel label="詳細説明" bold={false} />
        <InputNoticeList
          notices={[
            "例: 前年（1月から12月）の1年間の合計所得金額、所得控除額、課税標準額、前年所得に対する市・県民税額、扶養親族（人）などが記載されます。",
          ]}
        />
        <SimpleTextAreaInput
          basePath={[...basePath, "description"]}
          onChange={onChange}
          value={description}
          disabled={disabled}
          shouldDisplayError={shouldDisplayError}
          errorMsg={validationErrors?.description}
          maxLength={getMaxLength("issueFilesDescription")}
        />
      </div>

      <div className="mb-2">
        <FormFieldLabel label="注意書き" bold={false} />
        <InputNoticeList
          notices={[
            "例: 現年度分及び過去5年度分までに限ります。未申告の場合、申告後に証明可能です。",
          ]}
        />
        <SimpleTextAreaInput
          basePath={[...basePath, "notice"]}
          onChange={onChange}
          value={notice}
          disabled={disabled}
          shouldDisplayError={shouldDisplayError}
          errorMsg={validationErrors?.notice}
          maxLength={getMaxLength("issueFilesNotice")}
        />
      </div>
    </div>
  );
};

export default IssueFileInput;
